import LOGO from "./logo.png";
import { fontData } from "./encodedFont";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { ToWords } from "to-words";
import {
  checkEmptyOrNullString,
  formatNumberWithCommasandDecimals,
  formatODSText,
  numberToWords,
} from "../../../Utils/Utils";

function convertToDate(isoString) {
  const date = new Date(isoString);
  return date?.toISOString()?.split("T")[0]?.replace(/-/g, "/") || "";
}

export const wrapText = (text, maxLength) => {
  const result = [];
  let line = "";
  const words = text?.split(" ");
  for (let i = 0; i < words?.length; i++) {
    if ((line + words?.[i])?.length <= maxLength) {
      line += (line?.length ? " " : "") + words?.[i];
    } else {
      result.push(line);
      line = words[i];
    }
  }
  if (line) result.push(line);
  return result;
};

export const generatePDF = (responseData) => {
  const doc = new jsPDF();

  doc.addFileToVFS("NotoSansThai.ttf", fontData);
  doc.addFont("NotoSansThai.ttf", "NotoSansThai", "normal");
  doc.setFont("NotoSansThai");

  function addHeaderFooter(doc) {
    const pageCount = doc?.internal?.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(6);
      doc.text(`Page ${i} / ${pageCount}`, 180, 6);
      if (i > 1) {
        doc.setFontSize(6);
        doc.text(
          `Our Reference\n${responseData?.PONumber}\nDate: ${convertToDate(
            responseData?.PODate,
          )}`,
          130,
          6,
        );
      }
    }
  }
  const titleMain = "บริษัท เอจีซี วีนิไทย จํากัด(มหาชน)";
  const title = "AGC VINYTHAI PUBLIC COMPANY LIMITED";
  const xCoordinate = doc?.internal?.pageSize?.width / 2;
  const yCoordinate = 20;
  doc.setFontSize(12);
  doc.addImage(LOGO, "PNG", 10, 10, 35, 14);
  doc.text(titleMain, 60, 15);
  doc.text(title, 60, yCoordinate);

  doc.setFontSize(8);
  const vendorCode = responseData?.VendorCode || "";
  const vendorName = responseData?.VendorName || "";
  const vendorAddress = responseData?.VendorAddress || "";
  const vendorEmail = responseData?.VendorEmail || "";
  const vendorTel = responseData?.VendorTel || "";
  const vendorFax = responseData?.VendorFax || "";
  const vendorContactPerson = responseData?.VendorContactPerson || "";
  const wrappedVendorAddress = wrapText(vendorAddress, 50);

  let textContent = `VENDOR CODE:        ${vendorCode}\n${vendorName}\n\n\n\n\n`;
  wrappedVendorAddress.forEach((line) => {
    textContent += line + "\n";
  });
  textContent += `\n\nE-mail:   ${vendorEmail}\nTEL: ${vendorTel}              FAX: ${vendorFax}\nAttn:   ${vendorContactPerson}`;
  doc.text(textContent, 10, 40);

  doc.setFontSize(8);
  const shipToName = responseData?.AVTShipToName || "";
  const shipToAddress = responseData?.AVTShipToAddress || "";
  const shipToTel = responseData?.AVTShipToTel || "";
  const shipToFax = responseData?.AVTShipToFax || "";
  const wrappedAddress = wrapText(shipToAddress, 50);

  let shipToText = `SHIP TO ADDRESS:\n\n${shipToName}\n\n`;
  wrappedAddress.forEach((line) => {
    shipToText += line + "\n";
  });
  shipToText += `\n\n\nTEL: ${shipToTel}              FAX: ${shipToFax}`;
  doc.text(shipToText, 105, 40);
  doc.setFontSize(10);
  const subTitleMain = "ใบสั่งซื้อ";
  const subTitle = "PURCHASE ORDER";
  doc.setFontSize(8);
  doc.text(subTitleMain, xCoordinate, 95, { align: "center" });
  doc.text(subTitle, xCoordinate, 100, { align: "center" });
  doc.setLineWidth(0.25);

  doc.setFontSize(7);
  doc.setFont("NotoSansThai");

  const rows = [
    [
      `Person in charge`,
      `${responseData?.PurchasingGroup} \n${responseData?.PCMPersonInCharge} \nTEL: ${responseData?.PCMTel} | FAX: ${responseData?.PCMFax} \nEmail: ${responseData?.PCMEmail}`,
      `PO Number: ${responseData?.PONumber} | Date: ${convertToDate(
        responseData?.PODate,
      )}\nIncoterm: ${formatODSText(responseData?.PO_Incoterm)}`,
    ],
    [
      `Tax Invoice Details`,
      {
        content: `AGC VINYTHAI PUBLIC COMPANY LIMITED\n2, I-3 Road, Map Ta Phut Industrial Estate,\nMap Ta Phut Subdistrict, Mueang Rayong District, Rayong 21150 Thailand\nTAX ID: 0107565000395 Head Office.`,
        colSpan: 2,
      },
    ],
    [
      {
        content: `Payment Terms: ${responseData?.POPaymentTerm}`,
        colSpan: 3,
      },
    ],
    [
      `Requisitioner`,
      {
        content: `PR No.: \nTEL: `,
        colSpan: 2,
      },
    ],
    [
      {
        content: `${formatODSText(responseData?.ODS_Reference)}`,
        colSpan: 3,
      },
    ],
  ];
  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(0.125);

  doc.autoTable({
    body: rows,
    startY: 105,
    theme: "plain",
    styles: {
      font: "NotoSansThai",
      fontSize: 7,
      fontWeight: 400,
      cellPadding: 2,
      lineWidth: 0.125,
      lineColor: [0, 0, 0],
    },
    tableLineColor: [0, 0, 0],
    tableLineWidth: 0.125,
    margin: { left: 5, right: 5 },
  });

  const columns = [
    { header: "No", dataKey: "PrItemNumber" },
    { header: "Description", dataKey: `PrLongText` },
    { header: "Delivery date", dataKey: "PrDeliveryDate" },
    { header: "Qty", dataKey: "PrQTY" },
    { header: "Unit", dataKey: "Unit" },
    { header: "Unit Price ", dataKey: "PRUnit" },
    { header: `Amount (${responseData?.POCurrency})`, dataKey: "PRAmount" },
  ];

  const body = responseData?.poPrData?.map((row, rowIndex) => {
    const formattedDeliveryDate = convertToDate(row?.PrDeliveryDate);
    return columns.map((col) => {
      if (col.dataKey === "PrDeliveryDate") {
        return formattedDeliveryDate;
      }
      if (col.dataKey === "Unit") {
        return row?.PRUnit?.split("/")?.[1];
      }
      if (col.dataKey === "PRUnit") {
        return row?.PRUnit?.replace(/\n/g, " ");
      }

      if (col.dataKey === "PrLongText") {
        return `${formatODSText(row?.PrShortText)}\n${row?.PrMaterialNumber}\n\n${formatODSText(row?.PrLongText)}`;
      }
      if (col.dataKey === "PrQTY") {
        return formatNumberWithCommasandDecimals(row?.PrQTY, 3);
      }
      if (col.dataKey === "PrItemNumber") {
        return (rowIndex + 1) * 10;
      }
      if (col.dataKey === "PRAmount") {
        return formatNumberWithCommasandDecimals(row?.PRAmount);
      }
      return row[col.dataKey];
    });
  });

  const firstTableBottomY = doc?.lastAutoTable?.finalY;
  let currentY = firstTableBottomY;
  const tableStartX = 5;
  const tableWidth = 200;
  const colWidths = [10, 80, 25, 18, 15, 32, 20];
  const pageHeight = doc.internal.pageSize.height;
  const bottomMargin = 20;

  function drawTableHeader(doc, startY) {
    doc.setFontSize(7);
    doc.setFont("AngsanaNew", "normal");
    let currentX = tableStartX;
    const headerHeight = 8;

    doc.setDrawColor(0, 0, 0);
    doc.setLineWidth(0.125);
    columns.forEach((col, index) => {
      const colWidth = colWidths[index];
      if (index === 1) {
        doc.line(currentX, startY, currentX + colWidth, startY);
        doc.line(currentX, startY, currentX, startY + headerHeight);
        doc.line(
          currentX + colWidth,
          startY,
          currentX + colWidth,
          startY + headerHeight,
        );
      } else if (index === 0) {
        doc.line(currentX, startY, currentX + colWidth, startY);
        doc.line(currentX, startY, currentX, startY + headerHeight);
        doc.line(
          currentX + colWidth,
          startY,
          currentX + colWidth,
          startY + headerHeight,
        );
      } else {
        doc.rect(currentX, startY, colWidths[index], headerHeight);
      }

      doc.text(col.header, currentX + 1, startY + 5);
      currentX += colWidths[index];
    });

    doc.setFont("NotoSansThai", "normal");

    return startY + headerHeight;
  }

  currentY = drawTableHeader(doc, currentY);

  doc.setFont("NotoSansThai", "normal");

  let pageEndPositions = {};
  body.forEach((row, rowIndex) => {
    let maxRowHeight = 6;
    let cellHeights = [];
    let maxContentFitHeight = 6;

    row.forEach((cellData, colIndex) => {
      const cellText = String(cellData || "");
      const lines = doc.splitTextToSize(cellData, colWidths[colIndex] - 2);
      const cellHeight = Math.max(6, lines.length * 3 + 2);
      cellHeights[colIndex] = cellHeight;

      if (colIndex === 1) {
        maxRowHeight = Math.max(maxRowHeight, cellHeight);
      } else if (colIndex >= 2) {
        maxContentFitHeight = Math.max(maxContentFitHeight, cellHeight);
      }
    });

    const actualRowHeight = Math.max(maxRowHeight, maxContentFitHeight);
    let hasHeaderAbove = false;

    if (rowIndex === 0) {
      hasHeaderAbove = true;
    }
    const willFitOnCurrentPage =
      currentY + actualRowHeight <= pageHeight - bottomMargin;
    const currentPageNum = doc.internal.getCurrentPageInfo().pageNumber;
    if (!willFitOnCurrentPage) {
      pageEndPositions[currentPageNum] = currentY;
      const totalTableWidth = colWidths.reduce((sum, width) => sum + width, 0);
      const tableEndX = tableStartX + totalTableWidth;
      doc.setDrawColor(0, 0, 0);
      doc.setLineWidth(0.125);
      doc.line(tableStartX, currentY, tableEndX, currentY);
      doc.addPage();
      currentY = 15;
      currentY = drawTableHeader(doc, currentY);
      hasHeaderAbove = true;
    }
    doc.setDrawColor(0, 0, 0);
    doc.setLineWidth(0.125);
    let currentX = tableStartX;
    row.forEach((cellData, colIndex) => {
      const cellText = String(cellData || "");
      const lines = doc.splitTextToSize(cellText, colWidths[colIndex] - 2);

      let actualCellHeight;
      if (colIndex === 0 || colIndex === 1) {
        actualCellHeight = maxRowHeight;
      } else {
        actualCellHeight = maxContentFitHeight;
      }
      const colWidth = colWidths[colIndex];

      if (colIndex === 0 && hasHeaderAbove) {
        doc.line(currentX, currentY, currentX, currentY + actualCellHeight);
        doc.line(
          currentX,
          currentY + actualCellHeight,
          currentX + colWidth,
          currentY + actualCellHeight,
        );
        doc.line(
          currentX + colWidth,
          currentY,
          currentX + colWidth,
          currentY + actualCellHeight,
        );
      }

      if (colIndex === 1 && hasHeaderAbove) {
        doc.line(currentX, currentY, currentX, currentY + actualCellHeight);
        doc.line(
          currentX,
          currentY + actualCellHeight,
          currentX + colWidth,
          currentY + actualCellHeight,
        );
      } else {
        doc.line(currentX, currentY, currentX, currentY + actualCellHeight);
        doc.line(currentX, currentY, currentX + colWidth, currentY);
        doc.line(
          currentX,
          currentY + actualCellHeight,
          currentX + colWidth,
          currentY + actualCellHeight,
        );
      }

      if (lines.length > 0) {
        let textY = currentY + 3;
        lines.forEach((line) => {
          doc.text(line, currentX + 1, textY);
          textY += 3;
        });
      }

      currentX += colWidths[colIndex];
    });

    currentY += actualRowHeight;
  });
  const finalPageNum = doc.internal.getCurrentPageInfo().pageNumber;
  pageEndPositions[finalPageNum] = currentY;

  const totalTableWidth = colWidths.reduce((sum, width) => sum + width, 0);
  const tableEndX = tableStartX + totalTableWidth;
  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(0.125);
  doc.line(tableStartX, currentY, tableEndX, currentY);

  const currentPageNum = doc.internal.getCurrentPageInfo().pageNumber;
  for (let pageNum = 1; pageNum <= currentPageNum; pageNum++) {
    doc.setPage(pageNum);
    let pageTableStartY, pageTableEndY;

    if (pageNum === 1) {
      pageTableStartY = firstTableBottomY;
      pageTableEndY = pageEndPositions[pageNum] || currentY;
    } else {
      pageTableStartY = 15 + 8;
      pageTableEndY = pageEndPositions[pageNum];
    }

    doc.setDrawColor(0, 0, 0);
    doc.setLineWidth(0.125);
    doc.line(tableEndX, pageTableStartY, tableEndX, pageTableEndY);
  }

  doc.setPage(currentPageNum);

  const secondTableBottomY = currentY;
  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(0.125);

  const totalsRows = [];

  totalsRows.push([
    { content: "", styles: { halign: "right" } },
    {
      content: `(${responseData?.POCurrency || ""})`,
      styles: { halign: "right" },
    },
  ]);

  totalsRows.push([
    { content: "SUB TOTAL", styles: { halign: "right" } },
    {
      content:
        formatNumberWithCommasandDecimals(responseData?.POSubTotal) || "",
      styles: { halign: "right" },
    },
  ]);

  totalsRows.push([
    {
      content: `VAT ${formatNumberWithCommasandDecimals(responseData?.POVatPercent) || ""}%`,
      styles: { halign: "right" },
    },
    {
      content:
        formatNumberWithCommasandDecimals(responseData?.POVatAmount) || "",
      styles: { halign: "right" },
    },
  ]);

  if (
    responseData?.PO_Freight &&
    checkEmptyOrNullString(responseData?.PO_Freight)
  ) {
    totalsRows.push([
      { content: "Freight", styles: { halign: "right" } },
      {
        content:
          formatNumberWithCommasandDecimals(responseData?.PO_Freight) || "",
        styles: { halign: "right" },
      },
    ]);
  }

  if (
    responseData?.PO_Insurance &&
    checkEmptyOrNullString(responseData?.PO_Insurance)
  ) {
    totalsRows.push([
      { content: "Insurance Cost", styles: { halign: "right" } },
      {
        content:
          formatNumberWithCommasandDecimals(responseData?.PO_Insurance) || "",
        styles: { halign: "right" },
      },
    ]);
  }

  if (
    responseData?.PO_PackingFee &&
    checkEmptyOrNullString(responseData?.PO_PackingFee)
  ) {
    totalsRows.push([
      { content: "Packaging Fees", styles: { halign: "right" } },
      {
        content:
          formatNumberWithCommasandDecimals(responseData?.PO_PackingFee) || "",
        styles: { halign: "right" },
      },
    ]);
  }

  if (
    responseData?.PO_Surveyor &&
    checkEmptyOrNullString(responseData?.PO_Surveyor)
  ) {
    totalsRows.push([
      { content: "Surveyor Fees", styles: { halign: "right" } },
      {
        content:
          formatNumberWithCommasandDecimals(responseData?.PO_Surveyor) || "",
        styles: { halign: "right" },
      },
    ]);
  }

  if (
    responseData?.PO_StoreExpense &&
    checkEmptyOrNullString(responseData?.PO_StoreExpense)
  ) {
    totalsRows.push([
      { content: "Store Expense", styles: { halign: "right" } },
      {
        content:
          formatNumberWithCommasandDecimals(responseData?.PO_StoreExpense) ||
          "",
        styles: { halign: "right" },
      },
    ]);
  }

  if (
    responseData?.PO_OtherCommission &&
    checkEmptyOrNullString(responseData?.PO_OtherCommission)
  ) {
    totalsRows.push([
      { content: "Other Commission", styles: { halign: "right" } },
      {
        content:
          formatNumberWithCommasandDecimals(responseData?.PO_OtherCommission) ||
          "",
        styles: { halign: "right" },
      },
    ]);
  }

  totalsRows.push([
    {
      content: `(${numberToWords(responseData?.POTotalAmount || 0)} ${responseData?.POCurrency || ""})           Total Amount`,
      styles: { halign: "right" },
    },
    {
      content:
        formatNumberWithCommasandDecimals(responseData?.POTotalAmount) || "",
      styles: { halign: "right" },
    },
  ]);

  doc.autoTable({
    body: totalsRows,
    startY: secondTableBottomY,
    theme: "plain",
    columnStyles: {
      0: { cellWidth: 175 },
      1: { cellWidth: 25 },
    },
    styles: {
      font: "AngsanaNew",
      fontSize: 7,
      fontWeight: 400,
      cellPadding: { top: 1, right: 2, bottom: 0, left: 2 },
      minCellHeight: 3,
    },
    tableLineColor: [0, 0, 0],
    tableLineWidth: 0.125,
    margin: { left: 5, right: 5 },
  });

  doc.addPage();
  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(0.125);
  doc.autoTable({
    body: [
      [
        `Authorized by\n\n\n${responseData?.AuthorizedBy}\n\n\n${convertToDate(
          responseData?.AuthorizedDate,
        )}`,
        "Authorized by",
        "Authorized by",
      ],
      [
        {
          content: `-This purchase order has been approved by the authorized person & is valid without signature for less than 10 MTHB amount excluding vat, & is valid with signature for more than or equal 10 MTHB amount excluding vat`,
          colSpan: 3,
        },
      ],
    ],
    startY: 15,
    theme: "plain",
    styles: {
      font: "NotoSansThai",
      fontSize: 7,
      fontWeight: 400,
      cellPadding: 2,
      lineWidth: 0.125,
      lineColor: [0, 0, 0],
    },
    tableLineColor: [0, 0, 0],
    tableLineWidth: 0.125,
    margin: { left: 5, right: 5 },
  });

  const thirdTableBottomY = doc?.lastAutoTable?.finalY;
  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(0.125);
  doc.autoTable({
    body: [
      [
        "ACKNOWLEDGEMENT BY\n\n\nNAME:                                                                              DATE:\n\n\n- Please return the Order Acknowledgement with your signature via e-mail or fax within 3 working days",
      ],
    ],
    startY: thirdTableBottomY + 5,
    theme: "plain",
    styles: {
      font: "NotoSansThai",
      fontSize: 7,
      fontWeight: 400,
      cellPadding: 5,
      lineWidth: 0.125,
      lineColor: [0, 0, 0],
    },
    tableLineColor: [0, 0, 0],
    tableLineWidth: 0.125,
    margin: { left: 5, right: 5 },
  });

  const fourthTableBottomY = doc?.lastAutoTable?.finalY;
  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(0.125);

  doc.autoTable({
    body: [
      [
        "- Invoices without a purchase order reference will not be paid.\n- The instructions, specifications, Payment Term & condition as appearing on the purchase order or any attachments are made a part, hereof, which seller agreed by acceptance this order.\n- Due to limited space available, AGC VINYTHAI have no parking area for the contractors on this Contract.\n- This order is complied with documents as per below link:\nhttp://www.agcvinythai.com/en/supply-chain/pcm",
      ],
    ],
    startY: fourthTableBottomY + 5,
    theme: "plain",
    styles: {
      font: "NotoSansThai",
      fontSize: 7,
      fontWeight: 400,
      cellPadding: 5,
      lineWidth: 0.125,
      lineColor: [0, 0, 0],
    },
    tableLineColor: [0, 0, 0],
    tableLineWidth: 0.125,
    margin: { left: 5, right: 5 },
  });

  addHeaderFooter(doc);
  doc.save(`purchase-order-${responseData?.PONumber}.pdf`);
};